const sentryConfig = {
    // 'pageKey': [],	// 如果没有设置pageKey，则全部页面都上传。如果设置了pageKey,则对应的页面才上传
    dnsKey: '47768c523f234cb588900cbe0f5600dc',
    dnsNumber: '83',
    apiToken: '60386789dd6e4cca97171426a04ccd6efc3ca6812ffb4d1eb74d3de78a749fa1',
    projectId: 'pc-ul'
}

module.exports = sentryConfig
